import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { FilterDateRange } from '../../../filters.types';
const useDateOptions = () => {
  const $ = _c(27);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "components.filters.date-options"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("ui", t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("all-time");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = {
      value: FilterDateRange.AllTime,
      label: t1
    };
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("today");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = {
      value: FilterDateRange.Today,
      label: t3
    };
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("last-7-days");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = {
      value: FilterDateRange.Last7Days,
      label: t5
    };
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("last-30-days");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = {
      value: FilterDateRange.Last30Days,
      label: t7
    };
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = t("custom");
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t9) {
    t10 = {
      value: FilterDateRange.Custom,
      label: t9
    };
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t2 || $[23] !== t4 || $[24] !== t6 || $[25] !== t8) {
    t11 = [t2, t4, t6, t8, t10];
    $[21] = t10;
    $[22] = t2;
    $[23] = t4;
    $[24] = t6;
    $[25] = t8;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
};
export default useDateOptions;